// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> arbor-pointe
// Generated: 2026-11-04T23:46:29.125Z
// Counts: 0 design, 37 content, 23 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Anchorage from Your Doorstep</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover North Star Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Arbor Pointe in Anchorage, AK, enjoy the ease of community living and in-home essentials. Every apartment includes a dishwasher, energy-efficient appliances, an intercom/call box, a linen closet, and a private patio or balcony with scenic views. Community conveniences include 24-hour emergency maintenance, bike storage, controlled access building, a laundry facility, online payments and service requests, bilingual leasing staff, social events, and a smoke-free environment. Discover comfort and convenience right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Interested in learning more or scheduling a visit to Arbor Pointe in Anchorage, AK? Contact our friendly leasing team for information about our apartments, availability, and the community. We’re here to help you find your next home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect space at Arbor Pointe with studio and one-bedroom apartments for rent in Anchorage, AK. Each floor plan lets you spread out and stay organized, enjoy a private patio or balcony, a dishwasher, and energy-efficient appliances. Large closets and smart layouts make working from home and relaxing easy. Choose the floor plan that fits your lifestyle and get comfortable in a home designed for the way you live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Arbor Pointe Apartments in Anchorage, AK, through our photo gallery. Picture yourself relaxing in sunlit rooms, unwinding on your own balcony, and gathering with friends in inviting community spaces. Our gallery spotlights open kitchens, spacious living areas, and thoughtful details designed for comfort. Browse photos to get a sense of the warm ambiance and start imagining your new home here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Arbor Pointe Apartments puts you at the center of Anchorage life. Shop at Midtown Mall or Walmart, spend afternoons at Valley of the Moon Park or Westchester Lagoon, and enjoy quick access to local restaurants and entertainment. With the Spenard Thruway and public transit nearby, errands and adventures start right outside your door. Whether you want to bike Chester Creek Trail or catch a film at Bear Tooth Theatrepub, there’s always something to explore. Local employers, schools, and essential services are close by, making Arbor Pointe convenient for work, play, and everyday living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Arbor Pointe places you in the heart of Anchorage, close to Midtown Mall and nearby destinations. Wander through Valley of the Moon Park or grab a bite at one of the many nearby restaurants. Everything you need, from shopping to leisure, is within reach in Anchorage’s vibrant North Star neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for comfortable apartments for rent in Anchorage, AK? Come home to Arbor Pointe in the North Star neighborhood, near Midtown Mall, Walmart, Valley of the Moon Park, and Westchester Lagoon. Our community blends modern in-home comforts with welcoming spaces and planned resident events. Enjoy a pet-friendly lifestyle, a controlled-access building, and the ease of living near local favorites. Arbor Pointe brings convenience and community together, so you can spend more time doing what you love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Touring Arbor Pointe Apartments in Anchorage, AK, is simple; choose from virtual or in-person tours. View floor plans and community spaces with a guide who’s ready to answer your questions. Whether you prefer a walk-through at your own pace or want to connect online, our team will help you navigate your choices so you can picture life at Arbor Pointe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a feel for Arbor Pointe Apartments in Anchorage, AK, with our virtual tour feature. See the welcoming layouts, open living spaces, and community atmosphere at your own pace, right from your device. The virtual tour lets you picture your future home and lifestyle - all before you visit in person. Start your Anchorage apartment search and discover if Arbor Pointe matches your vision.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-96da-77f4-9592-9f4cef83692c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining area adjacent to a kitchen with orange countertops and white cabinets."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-96d9-7359-a90b-6ca9c964928b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A well-decorated bedroom with a queen-size bed, nightstands, and a window."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-b3ae-7403-ad33-a8902775b625.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Corner kitchen with orange countertops and wood cabinets, open to living area with large window."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-a515-74f8-89c2-82a87eb3ca7f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open concept studio apartment with kitchen, living area, and closet."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-96bc-71a5-a8c9-7e961a932374.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sectional sofa, coffee table, and balcony access."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-a9e8-734a-80fd-be69c6ec1754.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen area with orange countertops and white cabinets, connected to a living area with gray carpet."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-d29e-7306-8696-f4631fe247ff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of Arbor Pointe, a three-story Anchorage apartment building with private balconies"
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-b3ae-7403-ad33-a8902775b625.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Corner kitchen with orange countertops and wood cabinets, open to living area with large window."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-96d9-7359-a90b-6ca9c964928b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A well-decorated bedroom with a queen-size bed, nightstands, and a window."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167169/019d021b-96bc-71a5-a8c9-7e961a932374.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sectional sofa, coffee table, and balcony access."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
